// From https://novajs.co/react-hook-countdown

import { useState, useEffect, useRef } from 'react'
import * as D from 'date-fns'

interface Counter {
  current: string
  isPaused: boolean
  isOver: boolean
  pause: () => void
  play: () => void
  reset: () => void
  togglePause: () => void
}

export const useCountdown = (
  min: number,
  max: number,
  onOver?: () => void
): Counter => {
  const [count, setCount] = useState(max)
  const [paused, setPaused] = useState(false)
  const [isOver, setIsOver] = useState(false)
  const endTimeRef = useRef<Date>(D.addSeconds(new Date(), max))

  useEffect(() => {
    if (paused) {
      return
    }

    const interval = setInterval(() => {
      setCount(D.differenceInSeconds(endTimeRef.current, new Date()))
    }, 500)

    if (count <= min) {
      setIsOver(true)
      clearInterval(interval)
      onOver?.()
      return
    }

    return () => clearInterval(interval)
  }, [count, min, max, paused])

  return {
    current: count.toString(),
    isPaused: paused,
    isOver,
    pause: () => setPaused(true),
    play: () => setPaused(false),
    reset: () => {
      setIsOver(false)
      setCount(max)
    },
    togglePause: () => {
      setPaused(!paused)
    },
  }
}
